function showPrinciplesText(id){
  $(".principles_txt_container").css('display', 'none');
  $("#" + id).css('display', 'block');
}

function highlightPrincipleImg(n){
  $(".principle_img_container").removeClass('principle_img_container_active');
  $(n).addClass('principle_img_container_active');
}

$(document).ready(function() {
  
  function rotateOnMouse(e) {
  	var center_node = $("#wheel-center").find("svg");
  	
  	if(center_node) {
			var offset = center_node.offset();
      var center_x = offset.left + center_node.width() / 2;
      var center_y = offset.top + center_node.height() / 2;
      var mouse_x = e.pageX;
      var mouse_y = e.pageY;
      var radians = Math.atan2(mouse_x - center_x, mouse_y - center_y);
      var degree = radians * (180 / Math.PI) * -1;
      
      center_node.css('-moz-transform', 'rotate(' + degree + 'deg)');
      center_node.css('-webkit-transform', 'rotate(' + degree + 'deg)');
      center_node.css('-o-transform', 'rotate(' + degree + 'deg)');
      center_node.css('-ms-transform', 'rotate(' + degree + 'deg)');
		}   
  }

  $(document).mousemove(function(e) {
    e.preventDefault(); 
    rotateOnMouse(e);
  });

  //showPrinciplesText("principles_txt_all");

  $(".principle_img_container").removeClass('.principle_img_container_active');
});

